import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { PlannerFacade, ResRobotStopLocation, ResRobotTrip } from '@ridango/components';

import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-planner-trip-details',
    templateUrl: './planner-trip-details.component.html',
})
export class SchedulePlannerTripDetailsComponent implements OnInit, OnDestroy {
    private componentDestroyed$ = new Subject();
    trip: ResRobotTrip;

    @Input() tripId: number;

    selectedOrigin$: Observable<ResRobotStopLocation> = this.plannerFacade.selectedOrigin$;
    selectedDestination$: Observable<ResRobotStopLocation> = this.plannerFacade.selectedDestination$;

    trips$: Observable<ResRobotTrip[]> = this.plannerFacade.trips$;
    selectedTripId$: Observable<number> = this.plannerFacade.selectedTripId$;

    constructor(
        @Inject('ENV') public env: any,
        private plannerFacade: PlannerFacade,
        private router: Router,
        private translate: TranslateService
    ) {}

    ngOnInit() {
        this.trips$.pipe(takeUntil(this.componentDestroyed$)).subscribe((trips) => {
            if (trips && trips.length > 0) {
                if (this.tripId && trips[this.tripId]) {
                    this.trip = trips[this.tripId];
                } else if (trips && trips.length > 0) {
                    this.router.navigate([this.translate.currentLang, 'schedule', 'planner']);
                }
            } else {
                this.router.navigate([this.translate.currentLang, 'schedule', 'planner']);
            }
        });
    }

    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
}
